<template>
  <div class="aco-info-box">
    <b-col class="aco-details">
      <b-form @reset="reset" v-on:submit.prevent>
        <fieldset :disabled="loading">
          <b-row class="aco-details-row">
            <b-col>
              <b-row>
                <b-col><h5>{{ $t('bokbasenRawOrders') }}</h5></b-col>
              </b-row>
              <b-row class="aco-details-row">
                <b-col md="2">
                  {{ $t('sinceDays') }}
                  <font-awesome-icon id="sinceDaysTip" icon="info-circle"/>
                  <b-tooltip target="sinceDaysTip">{{ $t('toolTip.bokbasenSinceDaysSearchTip') }}</b-tooltip>
                </b-col>
                <b-col md="2">
                  <b-form-input id="sinceDays" type="number" min="1" max="365" v-model="bokbasenForm.sinceDays" v-on:keyup="onKeyup"/>
                </b-col>
                <b-col md="2">
                  <b-button type="reset" size="sm">{{ $t('reset') }}</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </fieldset>
      </b-form>
      <b-form-textarea v-if="bokbasenForm.rawDataList.length > 0" v-model="bokbasenForm.rawDataList" rows="30"></b-form-textarea>
    </b-col>
  </div>

</template>

<script>
  import BokbasenService from '../../services/BokbasenService'

  export default {
    data () {
      return {
        bokbasenForm: {
          sinceDays: '',
          rawDataList: [],
        },
        loading: false
      }
    },
    methods: {
      reset () {
        this.bokbasenForm.sinceDays = ''
        this.bokbasenForm.rawDataList = []
      },
      onKeyup (event) {
        if (event.which === 13) {
          this.loading = true
          BokbasenService.getBokbasenRawData(this.bokbasenForm.sinceDays)
            .then((response) => {
              this.bokbasenForm.rawDataList = response.data
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
